import { render, staticRenderFns } from "./BaseToken.vue?vue&type=template&id=5846501b&scoped=true&"
import script from "./BaseToken.vue?vue&type=script&lang=ts&"
export * from "./BaseToken.vue?vue&type=script&lang=ts&"
import style0 from "./BaseToken.vue?vue&type=style&index=0&id=5846501b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846501b",
  null
  
)

export default component.exports